import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesBasicForm } from './FormSamplesBasicForm';
import { FormSamplesBasicPageInfo } from './FormSamplesBasicPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// The UserDto interface below is an example of an existing interface you might use
// somewhere else in the project. It is defined here to show how to use it in this example
// but usually it will be defined somewhere else for other components to use
// - The input and output of the form will use this model
// - It ensures that the FormField attribute on the FormItem component has no spelling errors
/////////////////////////////////////////////////////////////////////////////////////////////
export interface UserDto {
  firstName: string;
  lastName: string;
}

export const FormSamplesBasicPage = () => {

  const [submittedValues, setSubmittedValues] = useState<UserDto | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false);
  const { showError } = useFeedback();

  const handleSubmit = async (values: UserDto) => {
    setSubmitting(true);
    setSubmittedValues(values);  // This is used just for examples - to show in the output window.

    try {
      // The below statement mimics an api call - a delay of 1 second to you can see what the form
      // looks like while submitting.
      // In the callMimicApi function, uncomment the exception in there to test errors coming from the api.
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      // Return false for an error - the form will remain open (and pristine will be false) for re submitting.
      // If true or undefined the form will take the values submitted as the new inisital values and will be marked
      // as pristine.
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Every page must be wrapped in a PageDefaultContainer
    // The PageContainer component below wraps the PageDefaultContainer and also
    // sets the title for each page
    // If you don't want to show a header add the noHeader prop to PageContainer 
    // (which will pass it to PageDefaultContainer)
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    <PageContainer
      heading='Form Samples - Basic'
      icon={<TextSnippetIcon />}
      pageInfo={<FormSamplesBasicPageInfo />}
      wrapRightElementForMobile={false}
    >
      <PageDefaultSegment width={400}>
        <FormSamplesBasicForm
          submitting={submitting}
          onSubmit={handleSubmit}
        />
      </PageDefaultSegment>
      <FormSamplesOutput width={400} submittedValues={submittedValues} />
    </PageContainer>
  )
}
